import { useEffect, useState } from "react";
import { fetchBrandList } from "../utils/brandList.js";

// Landing-page backdrop for the BRANDS wheel item: one diagonal "/" slice per
// brand, left to right in the same order the brands appear top to bottom on
// /brand (alphabetical, brands with live stock only — mirrors
// BrandCarousel's brandRows grouping). Every slice is a full-screen,
// cover-fitted copy of that brand's background clipped to its parallelogram,
// so each brand shows the part of its own image that sits at its position.
// Brands without a background keep their slot as a dark slice so positions
// still correspond. Reads the same warm caches the /brand page uses.
export default function HomeBrandSlices({ variant = "backdrop", onSelect, labels = false }) {
  const [slices, setSlices] = useState([]);

  // Order, live-stock rule and the video-background exclusion all live in
  // fetchBrandList — shared with the /brand index, so the two cannot drift
  // into offering different brands.
  useEffect(() => {
    let cancelled = false;
    fetchBrandList().then((list) => {
      if (!cancelled) setSlices(list);
    });
    return () => { cancelled = true; };
  }, []);

  if (!slices.length) return null;

  // "bands" is the /brands index: the same slices, same order, same images,
  // with the slant taken out — the page sets --slice-skew to 0, so each
  // parallelogram degenerates into a straight vertical band — at full
  // opacity, each one a button that opens its brand on /brand. The backdrop
  // variant the landing page uses is untouched.
  const bands = variant === "bands";
  const Slice = bands ? "button" : "div";
  return (
    <div
      className={`home-brand-slices${bands ? " home-brand-slices--bands" : ""}`}
      style={{ "--slice-count": slices.length }}
      aria-hidden={bands ? undefined : "true"}
    >
      {slices.map((s, i) => (
        <Slice
          key={s.name}
          type={bands ? "button" : undefined}
          aria-label={bands ? s.name : undefined}
          className={`home-brand-slice${s.url ? "" : " home-brand-slice--empty"}`}
          style={{ "--i": i, ...(s.url ? { backgroundImage: `url(${s.url})` } : {}) }}
          onClick={bands && onSelect ? () => onSelect(s.name) : undefined}
        >
          {bands && labels ? <span className="home-brand-slice__label">{s.name}</span> : null}
        </Slice>
      ))}
    </div>
  );
}
